import { AkaVeranstaltungId } from '../../../dtos.ts';
import { trpc } from '../../../trpc.ts';
import { HealthLevelIcon } from './HealthLevelIcon.tsx';

type Props = {
  akaVeranstaltungId: AkaVeranstaltungId;
  hideSuccessIcon?: boolean;
};

export const VeranstaltungHealthIcon = ({ akaVeranstaltungId, hideSuccessIcon = false }: Props) => {
  const { data } = trpc.veranstaltung.getHealthByVeranstaltung.useQuery({ akaVeranstaltungId });
  const healthLevels = data?.map((item) => item.type);
  return <HealthLevelIcon healthLevels={healthLevels} hideSuccessIcon={hideSuccessIcon} />;
};
